import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    name: 'home',
    path: '/',
    component: require('../views/Home.vue').default,
  },
  {
    name: 'select',
    path: '/select',
    component: require('../views/Select.vue').default,
  },
  {
    name: 'eyes',
    path: '/eyes',
    component: require('../views/Eyes.vue').default,
  },
  {
    name: 'view',
    path: '/view/:id',
    component: require('../views/View.vue').default,
  },
  {
    name: 'results',
    path: '/results',
    component: require('../views/Results.vue').default,
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
